module.exports = __webpack_public_path__ + "img/ebitda.1db847e8.svg";